<template>
  <div class="content">
    <div class="container-fluid">
      <h3>TLS</h3>
        <div class="col-md-12 ">
          <chart-card :key='tls_year_month_costs_data' :chart-data="tls_year_month_costs_data.data"
                      :chart-options="tls_year_month_costs_data.options"
                      :responsive-options="tls_year_month_costs_data.responsiveOptions"
                      chart-type="Line"
                      >
            <template slot="header">
              <h4 class="card-title">Costs with Certificates</h4>
              <p class="card-category">Values in $ (2018 - 2020)</p>
            </template>
            <template slot="footer">
              <div class="legend">
                <i class="fa fa-circle" :style='{color: colors[1]}'></i> executed
                <i class="fa fa-circle" :style='{color: colors[0]}'></i> projected

              </div>

              <hr>
              <div class="stats">
                <i class="fa fa-history"></i> Updated daily / page refreshed at {{last_update}}
              </div>
            </template>
          </chart-card>
        </div>
    </div>
    <hr/>
  </div>  
</template>
<script>
  import chartist from 'chartist'
  import ChartCard from 'src/components/Cards/ChartCard.vue'
  import StatsCard from 'src/components/Cards/StatsCard.vue'
  import LTable from 'src/components/Table.vue'
  import axios from 'axios'
  import main from 'src/main.js'
  import { colors, formatMoney, formatSimple, chart_base} from 'src/globalVariables'
  import { setInterval } from 'timers';

  import commit_info from '@/commit_info.txt'

  Number.prototype.pad = function(size) {
    var s = String(this);
    while (s.length < (size || 2)) {s = "0" + s;}
    return s;
  }

  export default {
    components: {
      LTable,
      ChartCard,
      StatsCard
    },
    props:{
        team:{
            type:String,
            default:'all',
        },
        product:{
            type:String,
            default:'all',
        },
    },
    async created() {
      this.accessToken = await this.$auth.getAccessToken()
      this.loadData()
      this.commit_info = commit_info
      var vm = this
      setInterval(function(){
        vm.loadData()
      },vm.refresh_minutes*60*1000)

    },
    methods: {
      loadData: function(){
        var today = new Date();
        this.last_update = today.getHours().pad(2) + ":" + today.getMinutes().pad(2) + ":" + today.getSeconds().pad(2)
        console.log('refreshing...',)
        axios.all([
            axios.get('tls/transactions-team?access_token=' + this.accessToken + '&st_date=20180101&fn_date=20211231&dimension=year-month&team='+ this.team+'&product='+this.product)
           
        ]).then(axios.spread((first, second, third) => {
            this.tls_year_month_costs = first.data;
            this.loading = false;
        }));

        return true
      },

      refresh_tls_year_month: function() {
        var labels = [] // year month
        var series = []
        var projected = []
        if (this.tls_year_month_costs){
          this.tls_year_month_costs.forEach(function(data, i){
            labels.push(data['date'])
            if (data['estimated']==0){
              series.push({meta:data['cost'],value:data['cost']})
            }
            projected.push({meta:data['cost'],value:data['cost']})
          })
          this.tls_year_month_costs_data = {
            'data': {
              'labels': labels,
              'series': [projected,series]
            },
            'options': Object.assign({}, chart_base.options),
            'responsiveOptions': Object.assign({}, chart_base.responsiveOptions),
          }
          //override of chart_base
          this.tls_year_month_costs_data.options.tooltip.tooltipOffset= {
                x: 15,
                y: 90
              }
          this.tls_year_month_costs_data.options.tooltip.tooltipFnc= function(meta, value) {
            var txt = document.createElement('textarea');
            txt.innerHTML = meta;
          return txt.value
        }
            this.tls_year_month_costs_data.options.lineSmooth= chartist.Interpolation.none()
        }
      }
    },
    watch: {
      tls_team_costs:function(){
        this.refresh_tls_team()
      },
      tls_date_costs:function(){
        this.refresh_tls_date()
      },
      tls_year_month_costs:function(){
        this.refresh_tls_year_month()
      },
    },
    computed: {
      
    },
    data () {
      return {
        refresh_minutes: 30,
        last_update: '',
        colors: colors,
        tls_team_costs:{},
        tls_team_costs_data:{},
        tls_date_costs:{},
        tls_date_costs_data:{},
        tls_year_month_costs:{},
        tls_year_month_costs_data:{},
        editTooltip: 'Edit Task',
        deleteTooltip: 'Remove',
      }
    }
  }
</script>
<style>

</style>
